<div class="tp-shell">
  <app-header></app-header>
  <div class="tp-body">
    <aside class="tp-sidebar">
      <app-side-bar></app-side-bar>
    </aside>
    <main class="tp-main">
      <app-tab-view></app-tab-view>
    </main>
  </div>
</div>